import { jwtDecode } from 'jwt-decode';
import { w3cwebsocket } from 'websocket';

import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

interface SendMessageParams {
  accessToken: string | null | undefined;
  createAccessToken: () => Promise<string | null>;
  openWs: (accessToken: string) => Promise<unknown>;
}

const useSendMsg = (
  ws: React.MutableRefObject<w3cwebsocket | null>,
  { accessToken, createAccessToken, openWs }: SendMessageParams,
) => {
  const { widget } = useWidgetContext();

  const getToken = () => {
    if (accessToken) return accessToken;
    return createAccessToken();
  };

  const sendMsg: Env.SendMesssage = async ({
    content,
    file_url,
    quotedMsgId,
    type,
  }) => {
    const token = await getToken();
    if (!token) return;

    const user = jwtDecode<Env.User>(token);

    const message = {
      chat_id: widget.instance_chat_key,
      content,
      file_url,
      quotedMsgId,
      sender_id: user.user_id,
      type,
    };

    if (!ws.current) await openWs(token);
    ws.current?.send(JSON.stringify(['message', message]));
  };

  return sendMsg;
};

export default useSendMsg;
